"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var fa_1 = require("react-icons/fa");
var _ = __importStar(require("lodash"));
var button_1 = __importDefault(require("../button"));
var icon_1 = __importDefault(require("../icon"));
var classnames_1 = __importDefault(require("classnames"));
require("../../styles/components/_dropdown.scss");
var Dropdown = /** @class */function (_super) {
  __extends(Dropdown, _super);
  function Dropdown() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.ref = react_1.default.createRef();
    _this.state = {
      showMenu: false
    };
    _this.hide = function (event) {
      if (_this.state.showMenu && _this.ref.current !== null) {
        if (event.target instanceof Element && !_this.ref.current.contains(event.target)) {
          _this.setState({
            showMenu: false
          });
        }
      }
    };
    _this.handleShowMenu = function () {
      _this.setState({
        showMenu: !_this.state.showMenu
      });
    };
    _this.handleDropdownSelect = function (sortByValue) {
      _this.handleShowMenu();
      _this.props.onChange(sortByValue);
    };
    return _this;
  }
  Dropdown.prototype.componentDidMount = function () {
    document.addEventListener("click", this.hide);
  };
  Dropdown.prototype.componentWillUnmount = function () {
    document.removeEventListener("click", this.hide);
  };
  Dropdown.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      sortOrder = _a.sortOrder,
      classname = _a.classname;
    var list = _.sortBy(this.props.list, 'key');
    var sortByValue = _.isEmpty(this.props.sortByValue) && list ? list[0] : this.props.sortByValue;
    return react_1.default.createElement("div", {
      className: 'ap-dropdown',
      ref: this.ref
    }, react_1.default.createElement("div", {
      className: (0, classnames_1.default)('dropdown', classname, {
        'is-active': this.state.showMenu
      }, {
        'is-hoverable': this.props.hoverable
      }, {
        'is-right': this.props.right
      })
    }, react_1.default.createElement("div", {
      className: 'dropdown-trigger'
    }, react_1.default.createElement("div", {
      className: 'buttons has-addons is-centered'
    }, react_1.default.createElement("a", {
      className: 'button is-static'
    }, this.props.title), react_1.default.createElement(button_1.default, {
      onClick: this.handleShowMenu
    }, react_1.default.createElement("span", null, sortByValue && sortByValue.value), !this.props.arrowless && react_1.default.createElement(icon_1.default, {
      fa: react_1.default.createElement(fa_1.FaSortDown, null)
    })), sortOrder && react_1.default.createElement(button_1.default, {
      onClick: this.props.onChangeSortOrder
    }, this.props.sortOrder === 'Descending' ? react_1.default.createElement(icon_1.default, {
      fa: react_1.default.createElement(fa_1.FaArrowDown, null)
    }) : react_1.default.createElement(icon_1.default, {
      fa: react_1.default.createElement(fa_1.FaArrowUp, null)
    })))), react_1.default.createElement("div", {
      className: 'dropdown-menu',
      role: 'menu'
    }, react_1.default.createElement("div", {
      className: 'dropdown-content'
    }, list && list.map(function (listItem) {
      return react_1.default.createElement("a", {
        className: (0, classnames_1.default)('dropdown-item', {
          'is-active': sortByValue && sortByValue.value === listItem.value ? true : false
        }),
        onClick: function () {
          return _this.handleDropdownSelect(listItem);
        }
      }, listItem.value);
    })))));
  };
  return Dropdown;
}(react_1.PureComponent);
exports.default = Dropdown;